/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

import SvgIcon from "@mui/material/SvgIcon";

const BusShelter = (props) => (
  <SvgIcon
    {...props}
    width="225.000000pt"
    height="225.000000pt"
    viewBox="0 0 225.000000 225.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,225.000000) scale(0.050000,-0.050000)"
      stroke="none"
    >
      <path
        d="M435 3727 c-414 -375 -456 -428 -415 -526 28 -69 95 -101 211 -101
l89 0 0 -1220 0 -1220 90 0 90 0 0 297 0 298 117 42 c64 24 123 43 130 43 7 0
13 -81 13 -180 l0 -180 80 0 80 0 0 200 0 200 140 0 140 0 0 90 0 90 -140 0
-140 0 0 770 0 770 521 0 521 0 -191 -225 c-179 -211 -226 -295 -165 -295 14
0 142 117 283 260 l257 260 237 0 c130 0 237 -5 237 -10 0 -6 -166 -205 -369
-442 -338 -396 -399 -488 -325 -488 12 0 228 211 479 470 l458 470 359 0 358
0 0 -770 0 -770 -140 0 -140 0 0 -90 0 -90 140 0 140 0 0 -200 0 -200 80 0 80
0 0 180 c0 99 6 180 13 180 7 0 66 -19 130 -43 l117 -42 0 -298 0 -297 90 0
90 0 0 1220 0 1220 89 0 c116 0 183 32 211 101 41 98 -1 151 -415 526 l-125
113 -1690 0 -1690 0 -125 -113z m596 -69 c28 -45 -439 -240 -494 -206 -37 23
-13 68 76 146 96 85 378 125 418 60z m-271 -1345 l0 -788 -117 -42 c-64 -24
-123 -43 -130 -43 -7 0 -13 374 -13 830 l0 830 130 0 130 0 0 -787z m3240 -43
c0 -456 -6 -830 -13 -830 -7 0 -66 19 -130 43 l-117 42 0 788 0 787 130 0 130
0 0 -830z"
      />
      <path d="M1420 1730 l0 -110 830 0 830 0 0 110 0 110 -830 0 -830 0 0 -110z" />
      <path
        d="M1375 1325 c-28 -63 -46 -122 -41 -130 11 -20 1821 -20 1832 0 5 8
-13 67 -41 130 l-50 115 -825 0 -825 0 -50 -115z"
      />
      <path d="M1544 945 c10 -227 135 -209 136 20 l0 115 -71 0 -71 0 6 -135z" />
      <path d="M2820 965 c1 -229 126 -247 136 -20 l6 135 -71 0 -71 0 0 -115z" />
    </g>
  </SvgIcon>
);
export default BusShelter;
